'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { ROUTES } from '../../../constants/routes';
import {
  isAuthenticatedSession,
  useAuthSession,
} from '../hooks/useAuthSession';

export function GuestOnly({ children }: { children: React.ReactNode }) {
  const { data: session } = useAuthSession();
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticatedSession(session)) {
      router.replace(ROUTES.admin);
    }
  }, [session, router]);

  if (isAuthenticatedSession(session)) {
    return null;
  }

  return <>{children}</>;
}
